import { useNavigate } from 'react-router-dom';
import { WebcamRecorder } from '../components/WebcamRecorder';

export function RecordVideo() {
  const navigate = useNavigate();

  const handleUploadSuccess = (entryId: string) => {
    navigate(`/entry/${entryId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-3xl font-bold text-gray-900">Record Video</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <p className="text-gray-600">
            Record a video journal entry with your webcam.
          </p>
        </div>

        <WebcamRecorder onComplete={handleUploadSuccess} />

        <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <h3 className="text-sm font-semibold text-blue-900 mb-2">Tips</h3>
          <ul className="text-sm text-blue-800 space-y-1 list-disc list-inside">
            <li>Grant camera and microphone permissions when prompted</li>
            <li>Ensure good lighting for better video quality</li>
            <li>Video is uploaded directly to Cloudflare Stream with resumable upload</li>
            <li>Your video will be automatically transcribed after upload</li>
          </ul>
        </div>
      </main>
    </div>
  );
}
